import React from 'react';
import {Link} from "react-router-dom";

const Service = () => {
    return (
        <section>
            <div className="container section-gap">
                <div className="row">
                    <div className="col-md-12"><h1 className="display-1 text-center text-uppercase">We offer
                        Services</h1></div>
                </div>
                <div className="row section-gap">
                    <div className="col-md-6 my-5">
                        <div className="service-card h-100">
                            <div className="icon">
                                <div className="icon-inner"><i className="fas fa-trash"></i></div>
                            </div>
                            <h4>General Clean Up</h4>
                            <p className="lead">Awesome! the best company that lets you clean and remove trash and rubbish anywhere LA county you want.</p>
                            <div className="link text-end"><Link to="/general-clean-up">Read More ...</Link></div>
                        </div>
                    </div>
                    <div className="col-md-6 my-5">
                        <div className="service-card h-100">
                            <div className="icon">
                                <div className="icon-inner"><i className="fa fa-building"></i></div>
                            </div>
                            <h4>Industries Clean Up</h4>
                            <p className="lead">Mega Dumpster Bin Rental does Construction
                            Trash Removal services around Los Angeles County &amp; San Fernando Valley.</p>
                            <div className="link text-end"><Link to="/construction-trash-removal">Read More ...</Link></div>
                        </div>
                    </div>
                    <div className="col-md-6 my-5">
                        <div className="service-card h-100">
                            <div className="icon">
                                <div className="icon-inner"><i className="fa fa-home"></i></div>
                            </div>
                            <h4>Residential Trash Removal</h4><p className="lead">Mega Season Removal does Residential
                            Trash Removal services around Los Angeles County &amp; San Fernando Valley.</p>
                            <div className="link text-end"><Link to="/residential-trash-removal">Read More ...</Link></div>
                        </div>
                    </div>
                    <div className="col-md-6 my-5">
                        <div className="service-card h-100">
                            <div className="icon">
                                <div className="icon-inner"><i className="fa fa-briefcase"></i></div>
                            </div>
                            <h4>Commercial Trash Removal</h4><p className="lead">Mega Dumpster Bin Rental does Commercial
                            Trash Removal services around Los Angeles County &amp; San Fernando Valley.</p>
                            <div className="link text-end"><Link to="/commercial-trash-removal">Read More ...</Link></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Service;
